import { RootState } from '../redux';

export const selectAuditTrail = (state: RootState) => {
  return state.auditTrail;
};
